import axios from 'axios'
const REACT_APP_API_URL = process.env.REACT_APP_API_URL

export const forgotPassword = async (email, appUrl) => {

  try {
    const url = `${REACT_APP_API_URL}/token-provider`
    const headers = {
      'Content-Type': 'application/json'
    }
    const body = {
      "type": "send_mail",
      "email": email,
      "url": `${appUrl}/changepassword`
    }
    const response = await axios.post(url, {...body}, {headers: headers})
    return response
  } catch (error) {
    const {response} = error
    return response
  }
}


